import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetVehicleReviewsQuery } from "../../../Data/services/vehicleApi";

export const useVehicleDetails = () => {
  const navigate = useNavigate();
  const { state: vehicleData } = useLocation();

  const {
    data: reviewData,
    isSuccess: isReviewSuccess,
    isLoading: isReviewLoading,
    isFetching: isReviewFetching,
    refetch: refetchReview,
  } = useGetVehicleReviewsQuery(
    {
      vehicle_id: vehicleData?.id,
    },
    { refetchOnMountOrArgChange: true }
  );

  return {
    navigate,
    vehicleData,
    isReviewFetching,
    reviewData,
  };
};